// engraving_free :: Produkt Gravur kostenlos
// engraving_cost :: Produkt kostenpflichtige Gravur
// engraving_free_after :: Preis ab dem die Gravur kostenlos ist


document.addEventListener('DOMContentLoaded', (ev) => {

    const targetNode = document.getElementById("sidebar-cart");
    const config = { attributes: false, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        document.querySelectorAll('.engraving_output_cart').forEach((e) => {
            if (e.innerHTML == '') {
                e.innerHTML = e.getAttribute('data-text')
            }
        })
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);


    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

});

document.addEventListener('click', (ev) => {


    if (ev.target.classList.contains('ProductForm__Engraving') || ev.target.closest('.ProductForm__Engraving') != null) {

        if (window.gravurPopupOpen != undefined) {
            if (window.gravurPopupOpen == true) {
                return;
            }

        }
        // checken ob von produkt seite oder aus cart aufgerufen
        if (ev.target.closest('.CartItem') != null) {
            // in cart aufgerufen
            let parent = ev.target.closest('.CartItem');
            initGravurPopup(parent.querySelector('.gravur-popup'), true);
        } else {
            // Produktseite aufgerufen                
            initGravurPopup(document.querySelector('.PageContainer .gravur-popup'));
        }
    }

    if (ev.target.classList.contains('removeEngraving')) {

        ev.preventDefault();
        let element = ev.target.closest('.CartItem');
        let lineitemid = element.dataset.lineitemid;

        fetch('/cart.js', {
            method: 'GET',
        })
            .then(response => response.text())
            .then(returnData => {

                let cart = JSON.parse(returnData);
                let items = cart.items;

                let gravurKostenpflichtig = {}; // 17531156934;
                let gravurKostenlos = {} // 13172897087565;


                let itemFound = undefined;

                for (const item of items) {
                    if (item.key === lineitemid) {
                        itemFound = item;
                    }

                    if (item.variant_id == engraving_cost) {
                        gravurKostenpflichtig = item;
                    }

                    if (item.variant_id == engraving_free) {
                        gravurKostenlos = item;
                    }
                }

                let updateData = new URLSearchParams();
                if (itemFound.price < engraving_free_after) {
                    if (gravurKostenpflichtig.key !== undefined) updateData.append('updates[' + gravurKostenpflichtig.key + ']', gravurKostenpflichtig.quantity - itemFound.quantity);
                } else {
                    if (gravurKostenlos.key !== undefined) updateData.append('updates[' + gravurKostenlos.key + ']', gravurKostenlos.quantity - itemFound.quantity);
                }


                /* ADD ENGRAVING PRODUCT TO CART */
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: updateData
                })
                    .then(response => response.text())
                    .then(returnData => {
                        removePropertyLineItem([
                            'engraving',
                            'engraving_font',
                            'engraving_fontsize',
                            'engraving_schreibhand',
                            'engraving_position'
                        ], lineitemid, (retval) => {
                            refreshCart();
                        });
                    })
                    .catch((returnError) => {
                        refreshCart();
                        closeGravurPopup();
                    });



            })
            .catch((returnError) => {
                refreshCart();
                closeGravurPopup();
            });


    }

})





function initGravurPopup(gravurPopup, openedFromCart = false) {


    function uuidv4() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    let dataProduct = {
        text: '',
        font: '',
        position: '',
        schreibhand: '',
        variant: '',
    };

    let originalParent = null;



    if (openedFromCart) {
        // element nach body kopieren                
        originalParent = gravurPopup.parentNode;
        gravurPopup = gravurPopup.cloneNode(true);
        document.querySelector('body').append(gravurPopup)
    }



    let symbolCount = 3;
    let symbolCountReplace = '';
    for (let i = 0; i < symbolCount; i++) {
        symbolCountReplace += '#';
    }



    let gravurFonts = JSON.parse(gravurPopup.dataset.fontlist);
    let closeButtonGravur = gravurPopup.querySelector('.closeButtonGravur');
    let gravur_fonts = gravurPopup.querySelector('.gravur_fonts_row');
    let text_element = gravurPopup.querySelector('.gravur-line-image-text');
    let textInput = gravurPopup.querySelector('[name=gravur_text]');
    let textInputVisible = gravurPopup.querySelector('[name=gravur_text_visible]');
    let image = gravurPopup.querySelector('.gravur-line-image-img');
    let gravur_schreibhand = gravurPopup.querySelector('[name=gravur_schreibhand]');
    let productselectors = gravurPopup.querySelector('[name=id]');
    let amount = gravurPopup.querySelector('[name=quantity]');
    let product__price = gravurPopup.querySelector('.product__price').value;
    

    /*

        {
            "color": "#f1b763",
            "positions": {
                "kappe": 16,
                "korpus": 12
            },
            "removefonts":[
                "victoria",
                "script",
                "script_rund"
            ]
        }

    */
    

    let maxOld = gravurPopup.dataset.maxchars;
    if ( maxOld == undefined ){
        maxOld = 16;
    } else {
        if ( maxOld.trim() == ''  ){
            maxOld = 16;
        }
    }
    

    let engravingOptions = {
        "removefonts": [],
        "positions": {
            "kappe": maxOld,
        }
    }

    if (gravurPopup.dataset.engravingOptions) {
        engravingOptions = Object.assign(engravingOptions, JSON.parse(gravurPopup.dataset.engravingOptions));
    }


    if (engravingOptions.color != undefined) {
        text_element.style.setProperty('--fontcolor-text', engravingOptions.color)
    }

    function setMaxCharacters(length) {
        textInputVisible.setAttribute('placeholder', textInputVisible.dataset.placeholder.replace('##', length));
        textInputVisible.setAttribute('maxlength', length);
        textInput.setAttribute('maxlength', length);
    }

    let positionFirst = gravurPopup.querySelector('[name=gravur_position]').value;
    setMaxCharacters(engravingOptions.positions[positionFirst]);

    gravurPopup.querySelector('[name=gravur_position]').classList.remove('hideme');
    if (gravurPopup.querySelector('.gv_helper') != null ){
        gravurPopup.querySelector('.gv_helper').parentNode.classList.add('select');
        gravurPopup.querySelector('.gv_helper').remove();

    }


    gravurPopup.querySelectorAll('[name=gravur_position] option').forEach((e) => {

        if (engravingOptions.positions[e.value] == undefined) {
            e.remove()

        }
    })

    if ( gravurPopup.querySelectorAll('[name=gravur_position] option').length == 1 ){
        let p = gravurPopup.querySelector('[name=gravur_position]');        

        let label = document.createElement('label');
        label.classList.add('element');
        label.classList.add('gv_helper');
        label.innerText = gravurPopup.querySelector('[name=gravur_position] option').innerText;
                
        
        gravurPopup.querySelector('[name=gravur_position]').parentNode.append(label);
        label.parentNode.classList.remove('select');
        p.classList.add('hideme');
    }



    let selectionStart = 0;
    let selectionEnd = 0;




    function checkLength(insertLength = 1) {
        let length = 0;
        for (let i = 0; i < textInputVisible.value.length; i++) {
            if (textInputVisible.value.charCodeAt(i) > 1000) {
                length += symbolCount;
            } else {
                length++;
            }
        }

        if ((length + insertLength) > textInput.getAttribute('maxlength')) {
            return false;
        }

        return true;
    }

    function calculateMaxLength() {
        let maxLengthDefault = textInput.getAttribute('maxlength');

        let length = 0;
        for (let i = 0; i < textInputVisible.value.length; i++) {
            if (textInputVisible.value.charCodeAt(i) > 1000) {
                maxLengthDefault -= symbolCount;
            }
        }

        textInputVisible.setAttribute('maxlength', maxLengthDefault);
    }


    textInputVisible.addEventListener('keyup', (e) => {

       

        selectionEnd = e.target.selectionEnd;
        selectionStart = e.target.selectionStart;
        calculateMaxLength();
        setProductValues();
    });

    textInputVisible.addEventListener('mouseup', (e) => {
        selectionEnd = e.target.selectionEnd;
        selectionStart = e.target.selectionStart;
    });


    gravurPopup.querySelectorAll('.icons .icon').forEach((el) => {

        if (el.classList.contains('ready')) return;

        el.classList.add('ready');
        el.addEventListener('click', (ev) => {


            let icon = el.querySelector('.svg-icon-img').getAttribute('html-entity');
            let char = el.querySelector('.svg-icon-img').getAttribute('char-insert');

            if (!checkLength(symbolCount)) return;

            textInputVisible.value = textInputVisible.value.slice(0, selectionStart) + char + textInputVisible.value.slice(selectionEnd);

            calculateMaxLength();
            setProductValues();

            setCaretPosition(textInputVisible, selectionEnd + 1);


        })
    })

    function setCaretPosition(elem, caretPos) {


        if (elem != null) {
            if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.move('character', caretPos);
                range.select();
            }
            else {
                if (elem.selectionStart) {
                    elem.focus();
                    elem.setSelectionRange(caretPos, caretPos);
                }
                else
                    elem.focus();
            }
        }
    }



    gravur_fonts.innerHTML = '';
    gravurFonts.forEach((f, i) => {

        let fontRadio = document.createElement('div');
        fontRadio.classList.add('option');

        let sumName = f.name.toLowerCase().replaceAll(' ', '_');
        if (engravingOptions.removefonts.includes(sumName)) {
            return;
        }

        let fontRadioInput = document.createElement('input');
        fontRadioInput.id = 'gravur_font_' + f.fontfile;
        fontRadioInput.name = 'gravur_font';
        fontRadioInput.type = 'radio';
        fontRadioInput.value = f.name.replaceAll(' ','_');
        fontRadioInput.setAttribute('fontOffset', f.fontsizeOffset);

        let fontRadioLabel = document.createElement('label');
        fontRadioLabel.setAttribute('for', 'gravur_font_' + f.fontfile)
        fontRadioLabel.innerHTML = f.name;
        fontRadioLabel.classList.add('element');
        fontRadioLabel.style.fontFamily = 'font_' + f.name.replaceAll(' ','_');


        fontRadio.append(fontRadioInput);
        fontRadio.append(fontRadioLabel);

        gravur_fonts.append(fontRadio);

        fontRadioInput.addEventListener('change', (ev) => {

            let fontFamily = ev.target.value;
            text_element.style.fontFamily = 'font_' + fontFamily;
            text_element.style.setProperty('--fontOffset', ev.target.getAttribute('fontOffset'));
            text_element.dataset.font = 'font_' + fontFamily;
            setProductValues();
        })

    })

    let uuid = uuidv4();
    gravurPopup.querySelectorAll('[id]').forEach((el) => {
        gravurPopup.querySelector('[for="' + el.id + '"]').setAttribute('for', el.id + uuid);
        el.id = el.id + uuid;
    })

    function getClearText() {

        let resultStr = '';


        for (let i = 0; i < textInputVisible.value.length; i++) {
            if (textInputVisible.value.charCodeAt(i) > 1000) {
                let imgElem = document.querySelector('.icon img[char-decimal="' + textInputVisible.value.charCodeAt(i) + '"]');
                resultStr += imgElem.getAttribute('html-entity');
            } else {
                resultStr += textInputVisible.value.substring(i, i + 1);
            }
        }

        if (resultStr != textInput.value) {

            text_element.innerHTML = '';

            let elements = [];

            for (let i = 0; i < textInputVisible.value.length; i++) {

                if (textInputVisible.value.charCodeAt(i) > 1000) {
                    let imgElem = gravurPopup.querySelector('.icon img[char-decimal="' + textInputVisible.value.charCodeAt(i) + '"]');
                    let clonedNode = imgElem.cloneNode(true);
                    clonedNode.setAttribute('src', clonedNode.getAttribute('data-transparent'));
                    elements.push(clonedNode);
                    
                } else {

                    
                    let char = textInputVisible.value.substring(i, i + 1);
                    if (char == ' ') {
                        char = '&nbsp;'
                    }

                    if ( elements.length > 0 ){
                        if ( Array.isArray( elements[ elements.length - 1 ] ) ){
                            elements[ elements.length - 1 ].push(char);   
                        } else {
                            elements.push([]);
                            elements[ elements.length - 1 ].push(char);
                        }
                    } else {
                        elements.push([]);
                        elements[ elements.length - 1 ].push(char);
                    }                  
                }
            }

            elements.forEach((e)=>{

                if ( Array.isArray(e) ){
                    let span = document.createElement('span');
                    span.innerHTML = e.join('');
                    text_element.append(span);

                } else {
                    text_element.append(e);
                }

            });


        }


        if ( resultStr.length > 0 ){
            gravurPopup.querySelector('.delete').classList.add('active');
        } else {
            gravurPopup.querySelector('.delete').classList.remove('active');

        }

        return resultStr;

    }


    function setProductValues() {

        

        dataProduct.schreibhand = gravur_schreibhand.value;
        dataProduct.variant = productselectors.value;

        

        textInput.value = getClearText();

    

        if ( textInputVisible.value == '' ){
            
            text_element.innerText = text_element.getAttribute('default');
        }
        
        dataProduct.text = textInput.value;
        dataProduct.fontfile = gravurPopup.querySelector('[name=gravur_font]:checked').value;
        dataProduct.position = gravurPopup.querySelector('[name=gravur_position]').value;

    }

    

    gravurPopup.querySelector('.delete').addEventListener('click',(ev)=>{
        textInput.value = '';
        textInputVisible.value = '';
        text_element.innerHTML = text_element.getAttribute('default');
        gravurPopup.querySelector('.delete').classList.remove('active');
    });


    // Produkt zur Cart hinzufügen
    gravurPopup.querySelector('.black-btn--engraving[data-action="open-drawer"]').addEventListener('click', (ev) => {

        let lineitemid = null;
        let lineitemamount = null;

        setProductValues();

        if (openedFromCart) {
            lineitemid = originalParent.closest('.CartItem').dataset.lineitemid
            lineitemamount = originalParent.closest('.CartItem').querySelector('.QuantitySelector__CurrentQuantity').value;
        }

        console.log('_11111');
        if (dataProduct.text.trim().length > 0) {

            console.log('_22222');

            let props = {
                engraving: dataProduct.text.trim(),
                engraving_font: dataProduct.fontfile,
                engraving_schreibhand: dataProduct.schreibhand,
                engraving_position: dataProduct.position,
            }

            if (document.querySelector('.giftlist_add') != null) {
                props['_can_have_gift'] = document.querySelector('.giftlist_add').value;
            }

            let dataPostEngraving = new URLSearchParams();
            if (parseInt(product__price) > parseInt(engraving_free_after)) {
                dataPostEngraving.append('id', engraving_free);
            } else {
                dataPostEngraving.append('id', engraving_cost);
            }
            

            if (lineitemid != null) {

                console.log('_333333');
                // wenn wir an ein vorhandes Produkt im Warenkorb eine Gravur anhängen
                dataPostEngraving.append('quantity', lineitemamount );

                // haben wir überhaupt eine Gravur?
                if (props.engraving.length > 0) {
                    addPropertyLineItem(props, lineitemid, function () {

                        /* ADD ENGRAVING PRODUCT TO CART */
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                            },
                            body: dataPostEngraving
                        })
                            .then(response => response.text())
                            .then(returnData => {
                                refreshCart();
                                closeGravurPopup();
                            })
                            .catch((returnError) => {
                                refreshCart();
                                closeGravurPopup();
                            });


                    });
                } else {
                    closeGravurPopup();
                }

            } else {
                // wenn wir ein neues Produkt + Gravur hinzufügen
                console.log('_4444');
                dataPostEngraving.append('quantity', amount.value );

                let dataPost = new URLSearchParams();
                
                dataPost.append('id', dataProduct.variant);
                dataPost.append('quantity', amount.value );

                console.log(props)

                Object.keys(props).forEach((key) => {
                    dataPost.append(`properties[${key}]`, props[key]);
                })



                if (props.engraving.length > 0) {

                   
                    /* ADD PRODUCT TO CART */
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                        },
                        body: dataPost
                    })
                        .then(response => response.text())
                        .then(returnData => {

                         

                            /* ADD ENGRAVING PRODUCT TO CART */
                            fetch(window.Shopify.routes.root + 'cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                                },
                                body: dataPostEngraving
                            })
                                .then(response => response.text())
                                .then(returnData => {
                                    refreshCart();
                                    closeGravurPopup();
                                })
                                .catch((returnError) => {
                                    refreshCart();
                                    closeGravurPopup();
                                });


                        })
                        .catch((returnError) => {
                            refreshCart();
                            closeGravurPopup();
                        });


                } else {
                    closeGravurPopup();
                }

            }



        }
    })

    if (productselectors != null) {
        productselectors.addEventListener('change', (ev) => {
            setProductValues();
        })
    }

    gravurPopup.querySelector('[name=gravur_position]').addEventListener('change', () => {

        setMaxCharacters(engravingOptions.positions[gravurPopup.querySelector('[name=gravur_position]').value])

        text_element.innerHTML = '';
        textInput.value = '';
        textInputVisible.value = '';
        //setProductValues()

    })



    gravur_schreibhand.addEventListener('change', (ev) => {

        
        setProductValues();
        if (gravur_schreibhand.value == 'links') {
            image.classList.add('mirror');
        } else {
            image.classList.remove('mirror');
        }
      
    })



    function showGravurPopup() {
        gravurPopup.classList.add('visible');
        gravurPopup.classList.remove('fromCart');
        document.querySelector('body').classList.add('no-scroll');
        document.querySelector('body').classList.add('engravingOverlay');
        textInput.value = '';
        textInputVisible.value = "";
        
        
        
        if (openedFromCart) {
            gravurPopup.classList.add('fromCart');
            document.querySelector('.PageOverlay').classList.remove('is-visible');
            document.getElementById('sidebar-cart').classList.add('d-none');
            
            productselectors.parentNode.style.display = 'none';
        }


        gravurPopup.querySelectorAll('.icons .icon img').forEach((el) => {



            if (el.offsetWidth == 0) {
                el.addEventListener('load', (ev) => {
                    if (el.src == el.dataset.transparent) return;
                    el.style.width = el.offsetWidth + 'px';
                    el.style.height = el.offsetHeight + 'px';
                    //el.src = el.dataset.transparent;

                })
            } else {
                el.style.width = el.offsetWidth + 'px';
                el.style.height = el.offsetHeight + 'px';
                //el.src = el.dataset.transparent;
            }


        });



        if (document.querySelectorAll('select[name=id][title=Variant] option').length > 1) {
            let v = document.querySelector('select[name=id][title=Variant]').value;

            if ( productselectors != null ){
                let a = productselectors.querySelector('option[value="' + v + '"]');
                if (a != null) {
                    productselectors.value = v;
                } else {
                    productselectors.value = productselectors.querySelector('option:first-child').value;
                }
            } else {
                gravurPopup.querySelector('.available').classList.add('not-available');
            }
        }

        text_element.innerHTML = text_element.getAttribute('default');
        window.gravurPopupOpen = true;

        gravurPopup.querySelectorAll('.options-row .option:first-child input').forEach((el) => {
            gravurPopup.querySelectorAll('[name="' + el.name + '"]').forEach((e, i) => {
                if (i == 0) {
                    e.checked = true;
                    text_element.style.fontFamily = 'font_' + e.value;
                    text_element.style.setProperty('--fontOffset', e.getAttribute('fontoffset') );
                    text_element.dataset.font = 'font_' + e.value;

                    return;
                }

                e.checked = false;
            })

        });

    }

    function closeGravurPopup() {
        gravurPopup.classList.remove('visible');
        document.querySelector('body').classList.remove('no-scroll');
        document.querySelector('body').classList.remove('engravingOverlay');
        window.gravurPopupOpen = false;
        if (openedFromCart) {
            document.querySelector('.PageOverlay').classList.add('is-visible');
            document.getElementById('sidebar-cart').classList.remove('d-none');
            gravurPopup.remove();
        }
    }

    gravurPopup.addEventListener('mousedown', (ev) => {



        if (ev.target.classList.contains('gravur-popup')) {
            closeGravurPopup();
        }
    })

    closeButtonGravur.addEventListener('click', (ev) => {
        closeGravurPopup();
    })

    showGravurPopup();

}




